__turbopack_context__.v({
  "hiddenMobile": "MiddotSeparator-module-scss-module__QQtf6W__hiddenMobile",
  "separator": "MiddotSeparator-module-scss-module__QQtf6W__separator",
  "visibleMobile": "MiddotSeparator-module-scss-module__QQtf6W__visibleMobile",
});
